const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b8fc1cc7ae67214a4c590743abd93a417074142f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["apply-frontend@adway"]={id:"b8fc1cc7ae67214a4c590743abd93a417074142f"};
      